module.exports = __webpack_public_path__ + "assets/img/Paste-Icon.e8d53622.svg";